import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
	ChildrenContainer,
	DetailPanel,
	Inner,
	PageHeader,
	PageSub,
	PageTitle,
	Section,
	Shell,
	Sidebar,
	SidebarIcon,
	SidebarItem,
	SidebarLabel,
	SidebarSectionLabel,
} from "./styles";
import Main from "../../../layout/main/Main";
import ModuleMarketplace from "./components/module-marketplace/ModuleMarketplace";
import {
	MdOutlineChecklist,
	MdOutlineComputer,
	MdOutlineMonetizationOn,
} from "react-icons/md";
import { useFilter } from "../../../../contexts/filterContext";

export default function GeneralConfig({
	userdata,
	clientId,
	clientContract,
	clientName,
}) {
	const { marketplaceSection, setMarketplaceSection } = useFilter();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<Main>
			<Main.Header style={{ padding: "0 82px" }}>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Configuración General
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Inner>
				<PageHeader>
					<Section>
						<PageTitle>Configuración General</PageTitle>
						<PageSub>Administrá los parámetros del sistema</PageSub>
					</Section>
				</PageHeader>

				<Shell>
					<Sidebar>
						<SidebarSectionLabel>Marketplace</SidebarSectionLabel>

						<SidebarItem
							$active={marketplaceSection === "general"}
							onClick={() => setMarketplaceSection("general")}
						>
							<SidebarIcon $active={marketplaceSection === "general"}>
								<MdOutlineComputer size={16} />
							</SidebarIcon>
							<SidebarLabel>Configuración General</SidebarLabel>
						</SidebarItem>

						<SidebarItem
							$active={marketplaceSection === "products"}
							onClick={() => setMarketplaceSection("products")}
						>
							<SidebarIcon $active={marketplaceSection === "products"}>
								<MdOutlineChecklist size={16} />
							</SidebarIcon>
							<SidebarLabel>Productos</SidebarLabel>
						</SidebarItem>

						<SidebarItem
							$active={marketplaceSection === "publicity"}
							onClick={() => setMarketplaceSection("publicity")}
						>
							<SidebarIcon $active={marketplaceSection === "publicity"}>
								<MdOutlineMonetizationOn size={16} />
							</SidebarIcon>
							<SidebarLabel>Publicidad</SidebarLabel>
						</SidebarItem>
					</Sidebar>

					<DetailPanel>
						<ChildrenContainer>
							<ModuleMarketplace
								clientContract={clientContract}
								clientName={clientName}
								activeSection={marketplaceSection}
							/>
						</ChildrenContainer>
					</DetailPanel>
				</Shell>
			</Inner>
		</Main>
	);
}
